import React, { useEffect, useState } from 'react';
import { HiLightBulb, HiOutlineLightBulb  } from "react-icons/hi2";
import { LuMoonStar } from "react-icons/lu";
import { FiSun } from "react-icons/fi";


const LightMode = () => {
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(()=>{
        const root = window.document.documentElement;
        console.log("root",root)
        if (isDarkMode) {
            root.classList.add('dark');
          } else {
            root.classList.remove('dark');
          }
    },[isDarkMode])
    const toggleDarkMode = () => {
        setIsDarkMode(!isDarkMode);
      };

  return (
    <div>
<button
      onClick={toggleDarkMode}
      className="flex items-center animate- p-1 bg-gray-300 dark:bg-gray-100 rounded-full transition duration-300"
    >
      {isDarkMode ? (
        <FiSun className="h-7 w-7 text-blue-500" />
      ) : (
        <LuMoonStar className="h-7 w-7 text-blue-600 dark:text-white" />
      )}
    </button>    </div>
  )
}

export default LightMode
